import React, { Suspense, useEffect, useRef } from 'react';

import './css/base.css';
import './css/theme.css';
import './css/layout.css';
import './css/global.css';

import { Routes, Route, useLocation } from 'react-router-dom';
import { Spinner } from 'e3-components';

import ProtectedLayout from './Layout/ProtedtedLayout';
import { useBoundStore } from 'e3-common/store/useBoundStore';
import loadable from '@loadable/component';
import Layout from './Layout/Layout';
import { LOCAL_STORAGE_KEYS, PAGE_RENDER_TYPE } from 'e3-common/constants/enumerates';
import { componentLoader } from 'e3-common/utils/componentUtil';
import PageContainer from './Layout/PageContainer';
import TabContainer from './Layout/TabContainer';
import { CREATE_TAB_LIST, THEME } from 'e3-common/constants/common';
import useTabMenu from 'e3-common/hooks/useTabMenu';
import { toPayload } from 'e3-common/utils/querystringUtil';
import ErrorBoundary from './ErrorBoundary';
import { getLocalStorageItem } from 'e3-common/utils/localStorageUtil';
import useAuth from 'e3-common/hooks/useAuth';

const Home = loadable(() => import('./pages/Home'));
const Login = loadable(() => import('./pages/Login'));

function App() {
    const { menuList, pageRenderType } = useBoundStore((state) => state.menu);
    const location = useLocation();
    const { createTabByNewId } = useTabMenu();
    const user = useBoundStore((state) => state.user);
    const openChk = useRef(false);
    const { refresh } = useAuth();

    useEffect(() => {
        // Check if the location exists,
        // verify if the menuList has been rendered,
        // and ensure that this is excuted only once(openChk .,Ref)
        if (location?.pathname && location?.search && menuList.length && !openChk.current) {
            // the reason for using `openChk` is that when an item is added to `menuList` using `createTabByNewId`. useEffect is triggered.
            openChk.current = true;
            const searchObj = toPayload(location.search);

            // get the location path name and split it..
            const pageNameSplit = location?.pathname?.split('/');
            const pageName = pageNameSplit?.[pageNameSplit?.length - 1];

            // get the location information for create tab
            const key = searchObj?.key;

            // muse be excuted for the defined list only. it is `movePageName`
            // if there are other cases for moving the page, you need to add them to `CREATE_TAB_LIST`
            const movePageName = CREATE_TAB_LIST.find((item) => pageName?.includes(item));

            if (movePageName && key) {
                // create tab
                createTabByNewId([key], movePageName, searchObj);
            }
        }
    }, [menuList]);

    useEffect(() => {
        if (user?.propStr1) {
            document.body.classList = [user?.propStr1];
        } else {
            document.body.classList = [THEME.DEFAULT];
        }
    }, [user]);

    useEffect(() => {
        const accessToken = getLocalStorageItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
        if (accessToken) {
            refresh(location.pathname);
        }
    }, []);

    return (
        // Routing 설정
        <Suspense fallback={<Spinner />}>
            <Routes>
                <Route path={import.meta.env.VITE_PUBLIC_URL} element={<Layout />}>
                    <Route
                        path={import.meta.env.VITE_PUBLIC_URL + '/login'}
                        element={
                            <>
                                <Login />
                            </>
                        }
                    />

                    {pageRenderType === PAGE_RENDER_TYPE.PAGE ? (
                        <Route
                            path={import.meta.env.VITE_PUBLIC_URL + '/*'}
                            element={
                                <>
                                    <Home />
                                </>
                            }
                        />
                    ) : null}
                    {pageRenderType === PAGE_RENDER_TYPE.PAGE &&
                        menuList.map((menuItem) => {
                            if (menuItem.programPath) {
                                const Component = componentLoader(menuItem.programPath);
                                return (
                                    <Route
                                        key={menuItem.menuId}
                                        path={
                                            import.meta.env.VITE_PUBLIC_URL +
                                            menuItem.programRoutePath
                                        }
                                        element={
                                            // menuItem.sideYn === 'Y' ? (
                                            <ProtectedLayout>
                                                <ErrorBoundary>
                                                    <PageContainer
                                                        menuName={menuItem.menuName}
                                                        menuId={menuItem.menuId}
                                                        helpYn={menuItem.helpYn}
                                                        menuNameList={menuItem.menuNameList}
                                                    >
                                                        <Component />
                                                    </PageContainer>
                                                </ErrorBoundary>
                                            </ProtectedLayout>
                                            // ) : (
                                            //   <Component />
                                            // )
                                        }
                                    />
                                );
                            }
                        })}
                    {pageRenderType === PAGE_RENDER_TYPE.TAB ? (
                        <>
                            <Route
                                path={import.meta.env.VITE_PUBLIC_URL + '/'}
                                element={<TabContainer />}
                            />
                            <Route
                                path={import.meta.env.VITE_PUBLIC_URL + '/*'}
                                element={<TabContainer />}
                            />
                        </>
                    ) : null}
                </Route>
            </Routes>
        </Suspense>
    );
}

export default App;
